import { Route, Routes, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { RoutesPublics } from './components/RoutesPublics';
import { RoutesPrivates } from './components/RoutesPrivates';

export default function Navigator() {

  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="text-gray-600">CargandoOOOOOOOOOOOOOOO...</div>
    </div>;
  }

  return (
    <Routes>
      {isAuthenticated ? 
        <>
          {RoutesPrivates.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              element={<route.main />}
          />
          ))}
        </>
      :
        <>
          {RoutesPublics.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            element={<route.main />}
          />
          ))}
          <Route
            path="*"
            element={<Navigate to="/" replace />}
          />
        </>
      }
    </Routes>
  )
}
